// extracted by mini-css-extract-plugin
export default {"container":"InsightsLayout_container__6ITf4","analytics":"InsightsLayout_analytics__4s7Yk","duration":"InsightsLayout_duration__s3N+J"};